import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {AgGridReact} from "ag-grid-react";
import Card from "../../../components/card";
import Button from "../../../components/button";
import moment from "moment";
import RemoveButtonCellRenderer from "../../../components/cell-renderer/remove-button-cell-renderer";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css"
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import {LocalizationAgGrid} from "../../../utils/localization-ag-grid";
import InputForm from "../../../components/input-form";
import {Dialog, DialogBackdrop, DialogPanel, DialogTitle} from "@headlessui/react";
import {FaTimes} from "react-icons/fa";
import InputText from "../../../components/input-text";
import Modal from "../../../components/modal";
import EquipmentButtons from "./equipment-buttons";
import general from "../../../utils/general";

const initialData = {
    cameras: 0,
    users: 0,
    ocr: 0,
    contactid: 0,
    mobile: 0,
    observation: ""
}
const LicenceTable = ({licences, gridRef, id, code, totalActiveLane, handleInput, wrapperClass, onClose, submit, onlyClose, autoSubmitOnModalSave = true}) => {
    const navigate = useNavigate();

    const [openModal, setOpenModal] = useState(false);
    const [pinnedBottomValues, setPinnedBottomValues] = useState({ date_start: "Total", cameras: 0, users: 0, ocr: 0, contactid: 0, mobile: 0 });
    const [open, setOpen] = useState(false);
    const [modalData, setModalData] = useState(initialData)
    const [modalTitle, setModalTitle] = useState("")
    const [editingRowIndex, setEditingRowIndex] = useState(null);
    const [newRow, setNewRow] = useState(false)
    const [modalApi, setModalApi] = useState(null)
    const [modalNode, setModalNode] = useState(null)

    useEffect(() => countRows(licences), [licences]);

    const modalRender = (params, title, api, node) => {
        setModalNode(node)
        setModalApi(api)
        setModalData(params?.node.data)
        setEditingRowIndex(params?.node.id)
        setModalTitle(title)
        setOpen(true);
    }

    const [columnDefs] = useState([
        {field: "date_start", headerName: "Inclusão", width: 100, editable: false, sort: 'desc', comparator: general.nullLastDateStringComparator},
        {field: "cameras", headerName: "Câmeras", width: 100},
        {field: "users", headerName: "Usuários", width: 100},
        {field: "ocr", headerName: "OCR", width: 100},
        {field: "contactid", headerName: "Patrimonial", width: 110},
        {field: "mobile", headerName: "Mobile", width: 100},
        {field: "observation", headerName: "Observações", flex: 1},
        {
            field: "",
            sortable: false,
            width: 100,
            editable: false,
            cellRenderer: EquipmentButtons,
            cellRendererParams: {
                modalRender: modalRender,
                title: "Licenças"
            }
        }
    ]);

    const defaultColDef = useMemo(() => ({resizable: false, editable: false, cellDataType: false}), []);

    const addLicence = useCallback((modalData) => {
        const newLicence = {
            date_start: moment().format("DD/MM/YYYY"),
            cameras: modalData.cameras,
            users: modalData.users,
            ocr: modalData.ocr,
            contactid: modalData.contactid,
            mobile: modalData.mobile,
            observation: modalData.observation,
        }

        gridRef.current?.api.applyTransaction({add: [newLicence]});
        setNewRow(false)
        if (autoSubmitOnModalSave) submit();
    }, [autoSubmitOnModalSave, gridRef, submit]);

    const openLicensing = (e) => {
        e.preventDefault();

        let message;
        let verifyId = true;

        gridRef.current?.api.forEachNode(({data}) => {
            if (verifyId) verifyId = !!data?.id;
        });

        if (!id) message = 'É necessário salvar o projeto antes.';

        if (!code) message = 'Projeto não possuí hash.';

        if (!verifyId) message = 'Há licença(s) não salva(s), é necessário salvar antes.';

        if (message) {
            toast.error(message);
            return;
        }

        navigate(`/licenses/${code}`);
    }

    const countRows = (rowData) => {
        const totals = rowData.reduce(
            (acc, row) => {
                acc.cameras += parseInt(row.cameras) || 0;
                acc.users += parseInt(row.users) || 0;
                acc.ocr += parseInt(row.ocr) || 0;
                acc.contactid += parseInt(row.contactid) || 0;
                acc.mobile += parseInt(row.mobile) || 0;
                return acc;
            },
            { cameras: 0, users: 0, ocr: 0, contactid: 0, mobile: 0 }
        );

        setPinnedBottomValues({ date_start: "Total", ...totals });
    }
    const handleLicense = (field, value) => {
        setModalData(prev => ({...prev, [field]: value}))
    }

    return (
        <>
            <Card title="Licenças" wrapperClass={wrapperClass}>
                <div className={"ag-theme-quartz grid"}>
                    <AgGridReact
                        ref={gridRef}
                        rowHeight={32}
                        rowData={licences}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        animateRows={false}
                        suppressRowClickSelection={true}
                        gridOptions={{localeText: LocalizationAgGrid}}
                        singleClickEdit={true}
                        stopEditingWhenCellsLoseFocus={true}
                        pinnedBottomRowData={[pinnedBottomValues]}
                        getRowStyle={(params) => {
                            if (params.node.rowPinned) {
                                return { pointerEvents: "none", fontWeight: "700"};
                            }
                        }}
                        domLayout='autoHeight'
                    />
                </div>

                <div className="flex justify-between mt-3">
                    <div className={"flex gap-3"}>
                        <Button onClick={() => {
                            setModalTitle("Licença")
                            setOpen(true);
                            setNewRow(true)
                            setModalData(initialData)
                        }} target="primary">
                            Adicionar licença
                        </Button>

                        <Button onClick={openLicensing} target="primary">
                            Gerar licença
                        </Button>
                    </div>

                    <Button onClick={() => setOpenModal(true)}>
                        Informar faixas ativas (Uso comercial)
                    </Button>
                </div>
            </Card>

            <Modal isOpen={open} onClose={() => {onlyClose(setOpen, setNewRow)}} title={modalTitle} className={"w-6/12"}>
                <div className="flex flex-col lg:grid grid-cols-1 gap-x-6 gap-y-4 lg:grid-cols-10 m-5">
                    <InputForm id="cameras" name="cameras" value={modalData.cameras} label="Câmeras" col="col-span-2" type="number"
                               onChange={({ target: { value } }) => handleLicense("cameras", value)} />

                    <InputForm id="users" name="users" value={modalData.users} label="Usuários" col="col-span-2" type="number"
                               onChange={({ target: { value } }) => handleLicense("users", value)}/>

                    <InputForm id="ocr" name="ocr" value={modalData.ocr} label="OCR" col="col-span-2" type="number"
                               onChange={({ target: { value } }) => handleLicense("ocr", value)}/>

                    <InputForm id="contactid" name="contactid" value={modalData.contactid} label="Patrimonial" col="col-span-2" type="number"
                               onChange={({ target: { value } }) => handleLicense("contactid", value)}/>

                    <InputForm id="mobile" name="mobile" value={modalData.mobile} label="Mobile" col="col-span-2" type="number"
                               onChange={({ target: { value } }) => handleLicense("mobile", value)}/>

                    <InputText id={"observation"} name={"observation"} value={modalData.observation} label={"Observação"} col="col-span-10"
                               onChange={({ target: { value } }) => handleLicense("observation", value)}/>
                </div>
                <div className="flex justify-end gap-2 px-3 py-3 border-t border-gray-300 bg-[#F2F2F2] rounded-b-lg">
                    <div className="flex justify-end gap-3">
                        {
                            !newRow &&
                            <RemoveButtonCellRenderer node={modalNode} api={modalApi} modal={true} setOpen={setOpen}></RemoveButtonCellRenderer>
                        }
                        {
                            newRow ?
                                <Button target="success" onClick={() => {
                                    if(newRow) addLicence(modalData)
                                    setOpen(false);
                                    }}>
                                    Salvar
                                </Button>
                                :
                                <Button target="success" onClick={() => onClose(setOpen, setNewRow, gridRef, editingRowIndex, modalData, autoSubmitOnModalSave)}>
                                    Salvar
                                </Button>
                        }

                    </div>
                </div>
            </Modal>

            <Dialog open={openModal} onClose={() => setOpenModal(false)} className="relative z-10">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-gray-700 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 max-w-3xl data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 w-[400px]"
                        >
                            <div className="bg-white py-4 border-b border-gray-300">
                                <DialogTitle as="h3" className="font-semibold leading-6 border-b border-gray-300 px-3 flex justify-between">
                                    Informar faixas ativas
                                    <span onClick={() => setOpenModal(false)} className="cursor-pointer">
                                        <FaTimes />
                                    </span>
                                </DialogTitle>
                                <div className="flex text-center justify-center mx-3 mt-2">
                                    <p className="flex items-center gap-2 ml-2 text-gray-500 text-lg select-none text-sm">
                                        Uso exclusivo do setor comercial para quando o número de faixas for diferente do número de câmeras.
                                    </p>
                                </div>
                                <div className="flex justify-center px-4 mt-4">
                                    <InputForm id="total_active_lane" col="w-full" type="number" min={0} value={totalActiveLane ?? ""} onChange={handleInput} />
                                </div>
                            </div>
                            <div className="flex justify-end gap-3 p-3">
                                <Button onClick={() => setOpenModal(false)}>Confirmar</Button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default LicenceTable;
